import { ArticleMeta } from 'types/blog';
import { meta as kobetsuShienKeikakuKakikata } from './articles/kobetsu-shien-keikaku-kakikata.meta';
import { meta as kobetsuShienKeikakuMisakuseiGensan } from './articles/kobetsu-shien-keikaku-misakusei-gensan.meta';
import { meta as gensanIchiran } from './articles/gensan-ichiran.meta';
import { meta as shienProgramMikouhyouGensan } from './articles/shien-program-mikouhyou-gensan.meta';
import { meta as jikoHyokaMikouhyouGensan } from './articles/jiko-hyoka-mikouhyou-gensan.meta';
import { meta as jihatsukanKetsujoGensan } from './articles/jihatsukan-ketsujo-gensan.meta';
import { meta as jouhouKouhyouMihoukokuGensan } from './articles/jouhou-kouhyou-mihoukoku-gensan.meta';
import { meta as bcpMisakuteiGensan } from './articles/bcp-misakutei-gensan.meta';
import { meta as gyakutaiBoushiMijisshiGensan } from './articles/gyakutai-boushi-mijisshi-gensan.meta';
import { meta as shintaiKousokuMijisshiGensan } from './articles/shintai-kousoku-mijisshi-gensan.meta';

// ==============================|| 記事の見出し一覧（本文は含まない） ||============================== //
//
// ★ 記事を増やすときにやることは、次の4つ。
//     1. src/const/blog/articles/<slug>.meta.ts にメタを書く
//     2. src/const/blog/articles/<slug>.ts に本文を書く（1の meta を展開する）
//     3. 下の ARTICLE_META に import して並べる
//     4. src/const/blog/registry.ts の ARTICLE_LOADERS に1行足す
//
//   ルーティング(/blog/<slug>)、一覧ページ、カテゴリ一覧、プリレンダリング、sitemap.xml は
//   すべてこの配列から自動で作られる。
//
// ★ ここで import してよいのは .meta だけ。本文(./articles/<slug>)を import しないこと。
//   一覧を描くだけのページが全記事の本文を読み込むようになり、
//   記事が増えるほどサイト全体が重くなる。本文は registry.ts 経由で、
//   その記事を開いた人にだけ配る。
//
// 並び順は「この配列の順」がそのまま一覧の順になる。新着順ではなく、
// 読ませたい順に並べられるようにあえて日付でソートしていない。
// いまの並びは「個別支援計画の2本 → 減算の全体像 → 減算率の大きい順」。

export const ARTICLE_META: ArticleMeta[] = [
    kobetsuShienKeikakuKakikata,
    kobetsuShienKeikakuMisakuseiGensan,
    gensanIchiran,
    shienProgramMikouhyouGensan,
    jikoHyokaMikouhyouGensan,
    jihatsukanKetsujoGensan,
    jouhouKouhyouMihoukokuGensan,
    bcpMisakuteiGensan,
    gyakutaiBoushiMijisshiGensan,
    shintaiKousokuMijisshiGensan
];
